import React from "react";
import { useIntl } from "react-intl";
import LockSVG from "assets/icons/base/lock.svg";
import GoAiguaSVG from "assets/icons/base/logo-image-access.svg";
import "./styles/noaccesspage.scss";

const NoAccesPage = () => {
    const intl = useIntl();
    return (
        <div className="no-access-page">
            <img className="logo" src={GoAiguaSVG} alt="GoAigua" />
            <div className="no-access-page__body">
                <img src={LockSVG} alt={"lock"} />
                <span className="title">
                    {intl.formatMessage({
                        id: "app.NoAccessPage.Title",
                    })}
                </span>
                <span className="description">
                    {intl.formatMessage({
                        id: "app.NoAccessPage.Description",
                    })}
                </span>
            </div>
        </div>
    );
};

export default NoAccesPage;
